/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Reference_Period_HelpInputs */



/**
* | output |
* | --- |
* | "Comparison baseline for measuring the savings made on this building, usually a heating season." |
*
* @param {Building_Reference_Period_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_reference_period_help = /** @type {((inputs?: Building_Reference_Period_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Reference_Period_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Comparison baseline for measuring the savings made on this building, usually a heating season.")
	return /** @type {LocalizedString} */ ("Base de comparaison pour mesurer les économies réalisées sur ce bâtiment, généralement une saison de chauffe.")
});